// utils/mergeTags.ts
export function applyStaticMergeTags(
  content: string,
  tags: Partial<{
    companyName: string;
    userName: string;
    userTitle: string;
    industry: string;
    businessType: string;
    action_count: string;
    overdue_count: string;
    due_today_count: string;
    total_pending_count: string;
    action_center_link: string;
    call_summary: string;
    google_calendar_url: string;
    outlook_calendar_url: string;
    // Contact information
    contact_name: string;
    contact_email: string;
    contact_phone: string;
    contact_company: string;
    // Legacy aliases
    email: string;
    name: string;
    phone: string;
    company: string;
    // ←←← Business merge tags ←←←
    hours: string;
    location: string;
    services: string;
  }>
) {
  const map: Record<string, string | undefined> = {
    '{{companyName}}': tags.companyName,
    '{{company_name}}': tags.companyName,
    '{{userName}}': tags.userName,
    '{{user_name}}': tags.userName,
    '{{userTitle}}': tags.userTitle,
    '{{user_title}}': tags.userTitle,
    '{{industry}}': tags.industry,
    '{{business_type}}': tags.businessType, // legacy/alt
    '{{businessType}}': tags.businessType,
    // Enhanced notification tags
    '{{action_count}}': tags.action_count,
    '{{overdue_count}}': tags.overdue_count,
    '{{due_today_count}}': tags.due_today_count,
    '{{total_pending_count}}': tags.total_pending_count,
    '{{action_center_link}}': tags.action_center_link,
    '{{call_summary}}': tags.call_summary,
    '{{google_calendar_url}}': tags.google_calendar_url,
    '{{outlook_calendar_url}}': tags.outlook_calendar_url,
    // Contact information merge tags
    '{{contact_name}}': tags.contact_name,
    '{{contact_email}}': tags.contact_email,
    '{{contact_phone}}': tags.contact_phone,
    '{{contact_company}}': tags.contact_company,
    // Business information merge tags
    '{{hours}}': tags.hours,
    '{{location}}': tags.location,
    '{{services}}': tags.services,
    // Legacy aliases for compatibility
    '{{email}}': tags.email || tags.contact_email,
    '{{name}}': tags.name || tags.contact_name,
    '{{phone}}': tags.phone || tags.contact_phone,
    '{{company}}': tags.company || tags.contact_company,
  };

  // Replace only known static tags; leave everything else (dynamic) intact.
  let out = content;
  for (const [needle, val] of Object.entries(map)) {
    if (typeof val === 'string' && val.length) {
      // global replace
      out = out.split(needle).join(val);
    }
  }
  return out;
}
